import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';

type BudgetBreadcrumbsProps = {
    headerTitle: string;
    parentTitle: string;
    parentLink: string;
    childTitle: string;
};

const StyLink = styled(Link, {
    name: 'StyLink',
})({
    color: 'inherit',
    textDecoration: 'none',
});

const StyBreadCrumb = styled(Typography, {
    name: 'StyButton',
})({
    fontWeight: '600',
    fontSize: '16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '35vw',
    cursor: 'pointer',
});

const StyBreadCrumbNotSelected = styled(StyBreadCrumb, {
    name: 'StyBreadCrumbSelected',
})({
    color: '#899FB1',
});

const StyBreadCrumbSelected = styled(StyBreadCrumb, {
    name: 'StyBreadCrumbSelected',
})(({ theme }) => ({
    color: theme.palette.primary.main,
}));
export default function CustomSeparator({
    parentTitle = '',
    parentLink = '',
    childTitle = '',
    headerTitle,
}: BudgetBreadcrumbsProps): React.ReactElement {
    // Title is decoded because some links are partially encoded
    // encodeURIComponent is necessary for names like "URBANISME/FONCIER" that break the URL
    const decodedChildTitle = decodeURIComponent(childTitle);
    const ChildComponent =
        decodedChildTitle === ''
            ? StyBreadCrumbSelected
            : StyBreadCrumbNotSelected;

    const onClick = () => {
        trackEventBudget(TRACKABLE_EVENTS.budget.ux.breadcrumbsClick, {
            destination: parentTitle,
        });
    };

    return (
        <div>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                {!parentLink && (
                    <StyLink to="/budget_home">
                        <Typography variant="h4" color="primary">
                            {headerTitle}
                        </Typography>
                    </StyLink>
                )}
                {parentTitle && (
                    <StyLink
                        to={parentLink}
                        className="e2e-dashboard-header-link"
                        onClick={onClick}
                    >
                        <Tooltip
                            title={parentTitle}
                            placement="top"
                            key="button-element"
                        >
                            <ChildComponent>{parentTitle}</ChildComponent>
                        </Tooltip>
                    </StyLink>
                )}
                {decodedChildTitle && (
                    <Tooltip
                        title={decodedChildTitle}
                        placement="top"
                        key="button-element"
                    >
                        <StyBreadCrumbSelected color="textPrimary">
                            {decodedChildTitle}
                        </StyBreadCrumbSelected>
                    </Tooltip>
                )}
            </Breadcrumbs>
        </div>
    );
}
